export enum ApplicationSourceTypeEnum {
    Online = 1,
    Event = 2,
    WalkIn = 3
}
